<h1 mat-dialog-title>ยืนยันการปิดเคส</h1>
<div mat-dialog-content>คุณต้องการปิดเคสด้วยหรือไม่?.</div>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close (click)="endCase(false)">ไม่</button>
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial (click)="endCase(true)">ใช่</button>
  </mat-dialog-actions>